import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';

import Photo from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Photo/Photo.jsx';
import MediaButton from 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Photos/MediaButton.jsx';
import 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.scss';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

class Photos extends React.Component {
    constructor(props) {
        super(props);
        this.onVideoButtonClick = this.onVideoButtonClick.bind(this);
        this.onPhotoButtonClick = this.onPhotoButtonClick.bind(this);
    }

    onVideoButtonClick() {
        this.props.toggleVideoModal();
    }

    onPhotoButtonClick() {
        AnalyticsService.gaTrigger(TAGS.USED_VDP_PICTURES(WindowProxy.location().pathname));
        this.props.togglePhotoLightBox(0);
    }

    render() {
        const pictures = this.props.pictures;
        const gallery = pictures.slice(0, 3);
        const hasVideo = this.props.video.url.length !== 0;

        const photos = gallery.map((photo, i) => (
            <Photo
                key={photo.url || `vehicle-picture-${i}`}
                photo={photo.url}
                index={i}
                openPhotoLightBox={this.props.togglePhotoLightBox}
            />
        ));

        const moreMediaButton = hasVideo ? (
            <div>
                <MediaButton
                    handleClick={this.onPhotoButtonClick}
                    id="vehicleBanner-picture-button"
                    className="vehicleBanner-video-button"
                    icon="icon-gallery"
                    text={LocaleService.t('PHOTO_AVAILABLE', { number: this.props.pictures.length })}
                />
                <MediaButton
                    handleClick={this.onVideoButtonClick}
                    className="vehicleBanner-video-button"
                    icon="icon-play-button"
                    text={LocaleService.t('SUMMARY.PLAY_VIDEO')}
                />
            </div>
        ) : (
            <MediaButton
                handleClick={this.onPhotoButtonClick}
                className="vehicleBanner-photo-button"
                icon="icon-gallery"
                text={LocaleService.t('PHOTO_AVAILABLE', { number: this.props.pictures.length })}
            />
        );

        return (
            <div className="vehicleBanner-photos clearfix">
                {photos}
                {moreMediaButton}
            </div>
        );
    }
}

Photos.propTypes = {
    pictures: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string,
            url: PropTypes.string,
        })
    ).isRequired,
    video: PropTypes.shape({
        url: PropTypes.string,
    }).isRequired,
    togglePhotoLightBox: PropTypes.func.isRequired,
    toggleVideoModal: PropTypes.func.isRequired,
};

Photos.displayName = 'Photos';

export default Photos;
